import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { ReactComponent as CheckSvg } from '../../../assets/svg/check_24px.svg';
import { ReactComponent as ChevronRight } from '../../../assets/svg/chevron_right.svg';
import ChevronDown from '../../SVG-components/chevron_down';
import styles from './CustomDropdown.module.scss';

interface CustomDropdownProps {
  options: {label: any, value: any}[];
  defaultValue?: string;
  onChange?: (value: string) => void;
}

export const CustomDropdown: React.FC<CustomDropdownProps> = ({
  options,
  defaultValue,
  onChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const findSelectedOption = (value: string) => {
    return options.find(option => option.value === value) || options[0];
  };

  const [selected, setSelected] = useState(() =>
    defaultValue ? findSelectedOption(defaultValue) : options[0]
  );

  useEffect(() => {
    if (defaultValue) {
      const newSelected = findSelectedOption(defaultValue);
      setSelected(newSelected);

      if (newSelected) {
        const selectedIndex = options.findIndex(option => option.value === newSelected.value);
        if (selectedIndex !== -1) {
          const selectedPage = Math.floor(selectedIndex / itemsPerPage);
          setCurrentPage(selectedPage);
        }
      }
    }
  }, [defaultValue, options]);

  useEffect(() => {
    if (isOpen && selected) {
      const selectedIndex = options.findIndex(option => option.value === selected.value);
      if (selectedIndex !== -1) {
        const selectedPage = Math.floor(selectedIndex / itemsPerPage);
        setCurrentPage(selectedPage);
      }
    }
  }, [isOpen, selected, options]);

  const handleSelect = (option: {label: any, value: any}) => {
    setSelected(option);
    onChange?.(option.value);
    setIsOpen(false);
  };

  const handleNextPage = () => {
    const itemsPerPage = 10;
    const totalPages = Math.ceil(options.length / itemsPerPage);
    setCurrentPage((prev) => (prev + 1) % totalPages);
  };

  const handlePrevPage = () => {
    const itemsPerPage = 10;
    const totalPages = Math.ceil(options.length / itemsPerPage);
    setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
  };

  const itemsPerPage = 10;
  const totalPages = Math.ceil(options.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const visibleOptions = options.slice(startIndex, startIndex + itemsPerPage);

  const showScrollUp = currentPage > 0;
  const showScrollDown = currentPage < totalPages - 1;
  const hasMultiplePages = options.length > 10;

  if (!selected) return null;

  return (
    <div className={styles.dropdownWrapper}>
      <button className={styles.toggleButton} onClick={() => setIsOpen(!isOpen)}>
        {selected.label}
        <span className={classNames(styles.chevronIcon, {[styles.isOpen]: isOpen})}>
          <ChevronDown />
        </span>
      </button>

      <ul
        className={`${styles.dropdownList} ${isOpen ? styles.dropdownListVisible : ''}`}
      >
        {hasMultiplePages && showScrollUp && (
          <li className={styles.topArrow} onClick={handlePrevPage}>
            <ChevronRight />
          </li>
        )}
        {visibleOptions.map((option) => (
          <li
            key={option.value}
            className={`${styles.dropdownItem} ${
              option.value === selected.value ? styles.selectedItem : ''
            }`}
            onClick={() => handleSelect(option)}
          >
            <div className={styles.itemContent}>
              {option.label}
              {option.value === selected.value && (
                <span className={styles.checkMark}>
                  <CheckSvg />
                </span>
              )}
            </div>
          </li>
        ))}
        {hasMultiplePages && showScrollDown && (
          <li className={styles.bottomArrow} onClick={handleNextPage}>
            <ChevronRight />
          </li>
        )}
      </ul>
    </div>
  );
};